import { IPermissionModel } from '../models/role.model';
import * as PermissionActions from './permission.actions';
import { IAppState } from '../../store/app.state';
import { Action, createReducer, createSelector, on } from '@ngrx/store';

export type State = IPermissionModel;

const initialState: State = {
  roles: [],
  permissions: [],
  cloneRole: null
};

const permissionReducer = createReducer(
  initialState,
  on(PermissionActions.GetRoleListSuccess, (_state, { payload }): State => {
    return payload;
  }),
  on(PermissionActions.GetRoleListFailed, (state, { payload }): State => {
    console.log(payload);
    return state;
  }),
  on(PermissionActions.EditRoleSuccess, (state, { payload: role }): State => {
    const roles = state.roles.map((otherRole) => (otherRole.roleID === role.roleID ? role : otherRole));
    return { ...state, roles };
  }),
  on(PermissionActions.EditRoleFailed, (state, { payload }): State => {
    console.log(payload);
    return state;
  }),
  on(PermissionActions.CreateRoleSuccess, (state, { payload: role }): State => {
    const roles = [role, ...state.roles];
    return { ...state, roles };
  }),
  on(PermissionActions.CreateRoleFailed, (state, { payload }): State => {
    console.log(payload);
    return state;
  }),
  on(PermissionActions.DeleteRoleSuccess, (state, { payload }): State => {
    const roles = state.roles.filter((role) => role.roleID !== payload);
    return { ...state, roles };
  }),
  on(PermissionActions.DeleteRoleFailed, (state, { payload }): State => {
    console.log(payload);
    return state;
  }),
  on(PermissionActions.CloneRole, (state, { payload: role }): State => {
    return { ...state, cloneRole: { ...role, roleID: '', display: role.display + ' (copy)' } };
  }),
  on(PermissionActions.CleanCloneRole, (state): State => {
    return { ...state, cloneRole: null };
  })
);

export const reducer = (state: State, action: Action): State => permissionReducer(state, action);

export const permissionsState = (state: IAppState) => state.permissions;
export const getRoles = createSelector(permissionsState, (state: State) => state.roles);
export const getPermissions = createSelector(permissionsState, (state: State) => state.permissions);
export const getCloneRole = createSelector(permissionsState, (state: State) => state.cloneRole);
